"use strict";

module.exports = function contains(root, n) {
  var node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }

  return false;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-menu/~/rc-util/lib/Dom/contains.js
 ** module id = 613
 ** module chunks = 0
 **/